import { MapStyle } from 'shared/map-exports';
import streetStyle from './parts/streetsStyle.json';
import satelliteStyle from './parts/satelliteStyle.json';
import topoStyle from './parts/topoStyle.json';

export const mapboxStreetStyle = streetStyle as unknown as MapStyle;

export const mapboxSatelliteStyle = satelliteStyle as unknown as MapStyle;

export const mapboxTopoStyle = topoStyle as unknown as MapStyle;
